module.exports = __webpack_public_path__ + "images/flushed-face-gif.gif";